import { useEffect, useState } from 'react';

const DATA_URL = '/data/weather-normals.json';

export default function useWeatherNormals() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError(null);

    fetch(DATA_URL)
      .then(res => {
        if (!res.ok) throw new Error(`Failed to load weather normals (${res.status})`);
        return res.json();
      })
      .then(json => {
        if (!isMounted) return;
        setData(json);
        setLoading(false);
      })
      .catch(err => {
        if (!isMounted) return;
        setError(err);
        setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { data, loading, error };
}
